export const Download = () => (
  <path
    d='M17 9.58824H14.1429V5H9.85714V9.58824H7L12 14.9412L17 9.58824ZM7 16.4706V18H17V16.4706H7Z'
    fill='currentColor'
  />
)
